var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{directives:[{name:"show",rawName:"v-show",value:(_vm.CHANNEL_YXL_STATEMENT || _vm.showTip),expression:"CHANNEL_YXL_STATEMENT || showTip"}],staticClass:"support"},[(_vm.isHwrl)?_c('p',[_vm._v("本服务由中华万年历联合壹心理提供")]):_c('p',[_vm._v("壹心理©提供内容及技术支持")])])}
var staticRenderFns = []

export { render, staticRenderFns }


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/loaders/templateLoader.js??vue-loader-options!./node_modules/vue-loader/lib??vue-loader-options!./src/components/common/yxlCopyright.vue?vue&type=template&id=1476679d&scoped=true&
// module id = null
// module chunks = 